import { combineReducers } from "redux";
import { productReducer, selectedProductReducer } from "./ProductReducer";
import { selectedUserReducer, userReducer } from "./UserReducer";

const reducers = combineReducers({
    allProducts: productReducer,
    product: selectedProductReducer,

    allUsers: userReducer,
    user: selectedUserReducer
})

export default reducers;